module.exports = __webpack_public_path__ + "8a71e5eb17831eaa267ed75bbffd8de5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/payments/activity_creation_sale.svg
// module id = 1766
// module chunks = 4